import dayjs from "dayjs";
function formatTime(time) {
    return dayjs(time).format('MM/DD/YYYY HH:mm:ss');
}
export default {
    punctuation: {
        comma: ', ',
        comma2: ', ',
    },
    stitching: (...strList) => strList.join(' '),
    book: (name) => ` "${name}" `,
    now: (name) => name + ' imediatamente',
    please: (name) => 'por favor ' + name + '',
    numberFormat(num, useEn = true) {
        if (!num) {
            return 0;
        }
        if (num < 1000) {
            return num;
        }
        if (num < 1000000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        if (num < 1000000000) {
            return (num / 1000000).toFixed(1) + 'M';
        }
        return `999.9M+`;
    },
    relativeTime(time) {
        const now = Date.now();
        const diff = now - time;
        if (diff < 1000 * 60) {
            return 'agora mesmo';
        }
        if (diff < 3600000) {
            return `${Math.floor(diff / 60000)} minutos atrás`;
        }
        if (diff < 86400000) {
            return `${Math.floor(diff / 3600000)} horas atrás`;
        }
        if (diff < 2592000000) {
            return `${Math.floor(diff / 86400000)} dias atrás`;
        }
        return formatTime(time);
    },
    absoluteTime: formatTime,
};
